"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DORA_URL = void 0;
exports.DORA_URL = 'https://dora.coz.io';
//# sourceMappingURL=index.js.map